module.exports = __webpack_public_path__ + "static/media/redrock-reflections.7dc1887d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/redrock-reflections.jpg
// module id = 146
// module chunks = 0